import React from "react";
import { Alert, Container, LinearProgress, Stack } from "@mui/material";

import ArticleDialog from "./article-management/ArticleDialog";
import ArticleEmptyState from "./article-management/ArticleEmptyState";
import ArticleGroupList from "./article-management/ArticleGroupList";
import ArticleHeader from "./article-management/ArticleHeader";
import ArticleSkeletonGrid from "./article-management/ArticleSkeletonGrid";
import ArticleToast from "./article-management/ArticleToast";
import ArticleToolbar from "./article-management/ArticleToolbar";
import DeleteArticleDialog from "./article-management/DeleteArticleDialog";
import useArticleManagement from "./article-management/useArticleManagement";

export default function ArticleManagement() {
    const {
        openDialog,
        loading,
        err,
        currentArtikel,
        editingIndex,
        deleteAsk,
        fieldErrors,
        toast,
        query,
        sortBy,
        gross,
        filteredSorted,
        groupedArticles,
        resolveArtikelIndex,
        setQuery,
        setSortBy,
        setToast,
        setDeleteAsk,
        fetchArticles,
        handleDialogOpen,
        handleDialogClose,
        handleEdit,
        handleDeleteAsk,
        handleDeleteConfirm,
        handleFieldChange,
        handleToggleHasAmount,
        handleSave,
    } = useArticleManagement();

    return (
        <>
            <ArticleHeader onRefresh={fetchArticles} onAdd={handleDialogOpen} />

            <Container maxWidth="lg" sx={{ mt: 4, pb: 6 }}>
                <Stack spacing={3}>
                    <ArticleToolbar query={query} sortBy={sortBy} onQueryChange={setQuery} onSortChange={setSortBy} />

                    {loading && <LinearProgress />}

                    {!loading && err && <Alert severity="error">{err}</Alert>}

                    {!loading && !err && filteredSorted.length === 0 && <ArticleEmptyState onAdd={handleDialogOpen} />}

                    {!err && filteredSorted.length > 0 && (
                        <ArticleGroupList
                            groups={groupedArticles}
                            resolveIndex={resolveArtikelIndex}
                            onEdit={handleEdit}
                            onDeleteAsk={handleDeleteAsk}
                        />
                    )}

                    {loading && <ArticleSkeletonGrid />}
                </Stack>
            </Container>

            <ArticleDialog
                open={openDialog}
                onClose={handleDialogClose}
                onSave={handleSave}
                editingIndex={editingIndex}
                currentArtikel={currentArtikel}
                fieldErrors={fieldErrors}
                gross={gross}
                onFieldChange={handleFieldChange}
                onToggleHasAmount={handleToggleHasAmount}
            />

            <DeleteArticleDialog
                open={Boolean(deleteAsk)}
                article={deleteAsk?.artikel}
                onClose={() => setDeleteAsk(null)}
                onConfirm={handleDeleteConfirm}
            />

            <ArticleToast toast={toast} onClose={() => setToast((prev) => ({ ...prev, open: false }))} />
        </>
    );
}
